import { useEffect, useState } from 'react';

import { encodeBase64 } from './encode-string';
import randomBackground1 from '../assets/images/card_images/class-card-bg_01.png';
import randomBackground2 from '../assets/images/card_images/class-card-bg_02.png';
import randomBackground3 from '../assets/images/card_images/class-card-bg_03.png';
import randomBackground4 from '../assets/images/card_images/class-card-bg_04.png';
import randomBackground5 from '../assets/images/card_images/class-card-bg_05.png';
import randomBackground6 from '../assets/images/card_images/class-card-bg_06.png';

const placeholderBackgrounds = [
  randomBackground1,
  randomBackground2,
  randomBackground3,
  randomBackground4,
  randomBackground5,
  randomBackground6,
];
export const generateRandomImage = (id: string): string => {
  const index =
    id
      .split('')
      .map(i => i.charCodeAt(0))
      .reduce((a, b) => a + b, 0) % 5;

  const placeholderImage =
    placeholderBackgrounds[index] || placeholderBackgrounds[0];

  if (placeholderImage && typeof placeholderImage === 'string') {
    return placeholderImage;
  }

  if (placeholderImage?.src) {
    return placeholderImage.src;
  }

  return '';
};

interface ProfileAvatarProps {
  id?: string;
}

export function usePlaceholderImage({ id }: ProfileAvatarProps) {
  const [src, setSrc] = useState(id ? generateRandomImage(id) : '');

  /**
   * Monitor localStorage updates to keep all instances of avatar in sync across tabs
   */
  const handleStorageUpdated = (e: StorageEvent) => {
    if (!id) {
      return;
    }
    const key = `au-placeholder-image-${encodeBase64(id)}`;
    const storedColor = localStorage.getItem(key);

    // Apply the stored color to all instances of the avatar
    if (e.key === key && storedColor) {
      setSrc(storedColor);
    }
  };

  useEffect(() => {
    if (id) {
      const key = `au-placeholder-image-${encodeBase64(id)}`;
      const storedColor = localStorage.getItem(key);
      if (storedColor) {
        setSrc(storedColor);
      } else {
        // If no color is stored for this user ID, generate a new one and store it
        localStorage.setItem(key, src);
      }
    }

    window.addEventListener('storage', handleStorageUpdated);

    return () => {
      window.removeEventListener('storage', handleStorageUpdated);
    };
  }, [id]);

  return src;
}
